import Cookies from "universal-cookie";
import { apiAgent } from "../../axiosConfig";
import { getCookieSetOptions } from "../../config/cookiesSettings";
import { checkTeamContext } from "../../teamContext/teamSwitchService";
import {
    updateCurrentUser,
    updateLoadError,
    updateLoadingStage,
} from "../../redux/currentUserSlice";

export const SET_USER = "SET_USER";
export const SET_USER_LOADING = "USER_LOADING";
export const SET_USER_ERROR = "USER_ERROR";

export const fetchCurrentUser = () => async (dispatch) => {
    const requestApiKey = new Cookies().get("api_key");
    const requestTeamId = new Cookies().get("team_id");
    dispatch(updateLoadingStage(true));
    await apiAgent({
        method: "get",
        url: "/users/validate",
        params: {},
    })
        .then((res) => {
            const cookies = new Cookies();
            if (cookies.get("api_key") !== requestApiKey) return window.location.reload();
            cookies.set("api_key", res.data.api_key, getCookieSetOptions());
            dispatch(updateCurrentUser(res.data));
            // The old team lookup may have finished before staff authentication.
            checkTeamContext(requestTeamId);
        })
        .catch((err) => {
            if (new Cookies().get("api_key") !== requestApiKey) return window.location.reload();
            let timedout = (err.code === 'ECONNABORTED' || err.response?.status === 500)
            dispatch(updateLoadError({ error_message: "Unvalidated User", timedout}));
        });
};
